import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { BaseResult } from '@app/components/common/BaseResult/BaseResult';
import { BaseButton } from '@app/components/common/BaseButton/BaseButton';
import * as S from '@app/pages/uiComponentsPages//UIComponentsPage.styles';
import { BaseCol } from '@app/components/common/BaseCol/BaseCol';
import loginBackground from '@app/assets/images/image.png';
import { useNavigate } from 'react-router-dom';
import { useEffect } from 'react';
const Card = styled(S.Card)`
  .ant-card-body {
    justify-content: center;
  }
`;

const ResultsPage: React.FC = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  useEffect(() => {
    sessionStorage.clear();
  }, []);
  return (
    <>
      <BaseCol>
        <Card style={{ background: loginBackground }}>
          <BaseResult
            className="BaseResult"
            status={'success'}
            title={t('Đăng ký thành công.')}
            style={{ background: loginBackground }}
            extra={
              <BaseButton block type="link" key="console" onClick={() => navigate('../')}>
                {t('Trang chủ')}
              </BaseButton>
            }
          />
        </Card>
      </BaseCol>
    </>
  );
};

export default ResultsPage;
